module.exports = __webpack_public_path__ + "img/metro-icon.0ae8a409.svg";